exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-right[data-v-52dc739e]{display:flex}\n", ""]);

// exports
